<script setup lang="ts">
import { computed } from "vue";
import { tenkoTypes } from "@/services/consts";
import i18n from '@/lang/i18n';

const props = defineProps<{
  modelValue: {
    is_active_ittenko: boolean;
    tenko_type: string;
    ittenko_secret_key: string;
    ittenko_company_id: string;
  };
  errors: {
    tenko_type: string;
    ittenko_secret_key: string;
    ittenko_company_id: string;
  };
  isEditableUser: boolean;
  windowInnerWidth: number;
}>()

const emit = defineEmits(["update:modelValue"]);

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3 align-center">
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4 pt-2">
        {{ i18n.global.t('pages.operationOffices.form.ittenko.setting') }}
      </h6>
    </v-col>
    <v-col :cols="windowInnerWidth > 800 ? 10 : 9">
      <v-row class="align-center">
        <v-col cols="1">
          <v-switch
            hide-details="auto"
            v-model="modelValue.is_active_ittenko"
            :disabled="!props.isEditableUser"
            color="blue"
          />
        </v-col>
        <v-col cols="8">
          <v-select
            v-if="modelValue.is_active_ittenko"
            hide-details="auto"
            class="small"
            v-model="modelValue.tenko_type"
            :disabled="!props.isEditableUser"
            :items="tenkoTypes"
            :error-messages="errors?.tenko_type"
          >
          </v-select>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-row
    v-if="modelValue.is_active_ittenko && props.isEditableUser"
    class="text-form pl-4 pr-3 mb-3"
  >
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4">
        {{ i18n.global.t('pages.operationOffices.form.ittenko.id') }}<span style="color: red">✴︎</span>
      </h6>
    </v-col>
    <v-col :cols="windowInnerWidth > 800 ? 10 : 9">
      <v-text-field
        v-model="modelValue.ittenko_company_id"
        maxlength="255"
        :error-messages="errors?.ittenko_company_id"
      />
    </v-col>
  </v-row>
  <v-row
    v-if="modelValue.is_active_ittenko && props.isEditableUser"
    class="text-form pl-4 pr-3 mb-3"
  >
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4">
        {{ i18n.global.t('pages.operationOffices.form.ittenko.privateKey') }}<span style="color: red">✴︎</span>
      </h6>
    </v-col>
    <v-col :cols="windowInnerWidth > 800 ? 10 : 9">
      <v-text-field
        v-model="modelValue.ittenko_secret_key"
        maxlength="255"
        :error-messages="errors?.ittenko_secret_key"
      />
    </v-col>
  </v-row>
</template>
